/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import Provider from './src/context/Provider';

/**
 * Called when the Gatsby browser runtime first starts.
 *
 * @returns {Promise<void>}
 */
export const onClientEntry = async () => {
  if (typeof IntersectionObserver === `undefined`) {
    console.info('importing intersection-observer');
    await import(`intersection-observer`);
  }

  // Safely create a portal root in the browser only, and only once
  if (typeof document !== 'undefined' && typeof window !== 'undefined') {
    let portal = document.getElementById('portal');
    if (!portal) {
      portal = document.createElement('div');
      portal.id = 'portal';
      // Ensure body exists before appending
      if (document.body) {
        document.body.appendChild(portal);
      } else {
        // Fallback: append after DOM is ready
        window.addEventListener('DOMContentLoaded', () => {
          if (!document.getElementById('portal')) {
            const p = document.createElement('div');
            p.id = 'portal';
            document.body.appendChild(p);
          }
        });
      }
    }
  }
};

export const wrapRootElement = Provider;
